import Store from '@store';
import { headerAndFooter as config } from '@config';

export function deleteExistingPageNumbering () {
  const element = document.querySelector(config.pageNumbering.attribute.selector);
  element?.remove();
}

export function createPageNumberingElement (content, canvasSize, addToHeader) {
  const fontSize = config.pageNumbering.defaultFontSettings.size;
  const size = {
    width: fontSize * (content.length * 2)
  };
  const position = {
    x: canvasSize.width - size.width,
    y: addToHeader ? 0 : canvasSize.height - (fontSize * 2)
  };

  INKIVE.EditorFacade.handle('header_and_footer', 'open', {
    type: addToHeader
      ? 'headerView'
      : 'footerView'
  });

  INKIVE.DesignFacade.create('text', {
    content,
    size,
    position,
    font: { size: fontSize },
    meta: config.pageNumbering.attribute.value
  });
}

export function addPageNumbering (content, canvasSize, addToHeader) {
  deleteExistingPageNumbering();
  createPageNumberingElement(content, canvasSize, addToHeader);
}

export function replacePageNumbering (content) {
  const element = document.querySelector(config.pageNumbering.attribute.selector);
  if (!element) return;

  INKIVE.DesignFacade.set(element.id, {
    content
  });
}

export function createPageNumbering ({ section, numbering }) {
  const canvasSize = Store.getState().editor.canvasRelativeSize;
  const addToTop = section === 'header';

  if (numbering) {
    addPageNumbering(numbering, canvasSize, addToTop);
  }
}
